<template>
  <v-dialog :value="value" max-width="420" @input="$emit('input', $event)">
    <v-card class="crud-card">
      <v-card-title>Delete document?</v-card-title>
      <v-card-text>
        <p class="mb-0">
          Are you sure you want to delete
          <strong>{{ document.displayName }}</strong
          >?
        </p>
        <p v-if="fileCount" class="mt-2 mb-0">
          This removes the {{ fileCount }}
          {{ fileCount === 1 ? 'file' : 'files' }} uploaded under it.
        </p>
      </v-card-text>
      <v-card-actions class="crud-card-actions">
        <v-spacer />
        <GradientButton
          title="Cancel"
          callout=""
          :small="true"
          button-size="medium"
          :fill="false"
          :disabled="busy"
          @gradientButtonClicked="$emit('input', false)"
        />
        <v-btn
          rounded
          height="44"
          color="error"
          depressed
          class="ml-2 delete-confirm-btn"
          data-test="confirm-delete"
          :loading="busy"
          @click="confirm"
          >Delete</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { DELETE_TESTATOR_DOCUMENT_MUTATION } from '../../constants/graphql/testator-documents';
  import GradientButton from '../guest/GradientButton.vue';

  export default {
    name: 'DeleteDocumentDialog',
    components: { GradientButton },
    props: {
      value: { type: Boolean, default: false },
      document: { type: Object, required: true },
    },
    data() {
      return { busy: false };
    },
    computed: {
      fileCount() {
        return this.document.fileCount || 0;
      },
    },
    methods: {
      async confirm() {
        this.busy = true;
        try {
          await this.$apollo.mutate({
            mutation: DELETE_TESTATOR_DOCUMENT_MUTATION,
            variables: { id: this.document.id },
          });
          this.$emit('deleted', { id: this.document.id });
          this.$emit('input', false);
        } finally {
          this.busy = false;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../constants/styles/modal.scss';

  .delete-confirm-btn.v-btn.v-btn {
    padding: 0 24px;
    font-weight: 600;
    letter-spacing: normal;
  }
</style>
